module.exports = __webpack_public_path__ + "assets/img/home.3cddb5c2.svg";